import { render, staticRenderFns } from "./classOwnership.vue?vue&type=template&id=55fd973c"
import script from "./classOwnership.vue?vue&type=script&lang=js"
export * from "./classOwnership.vue?vue&type=script&lang=js"
import style0 from "./classOwnership.vue?vue&type=style&index=0&id=55fd973c&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports